import { CommonService } from 'app/services/common.service';
import { Component, Input, OnInit } from '@angular/core';

import { TableHead } from '../../../models';
import { CommonAuthenticationService, CommonDataSharedService } from './../../../services';

@Component({
  selector: '[table-head]',
  templateUrl: './table-head.component.html',
  styleUrls: ['./table-head.component.scss']
})
export class TableHeadComponent implements OnInit{
  @Input() tableHeadStructure: TableHead[] = [];
  @Input() tableData = [];
  @Input() tempItems = [];
  localStorageData;

  constructor(
    private _commonService: CommonService,
    private commonDataSharedService: CommonDataSharedService,
    private _commonAuthenticationService: CommonAuthenticationService
    ) { }

    ngOnInit() {
      this.localStorageData = this._commonAuthenticationService.getLoginData();
    }

  sortTable(columnName: string, column: TableHead) {
    this.tableData.sort(this._commonService.dynamicSort(columnName, false));
    if (column.sortAs) {
      this.tableData.sort(this._commonService.dynamicDateSort(columnName, false));
    }
  }

  onMultiCheckboxChange(event) {
    if (event.target.checked) {
      this.commonDataSharedService.isMultiCheck.next(true);
    } else {
      this.commonDataSharedService.isMultiCheck.next(false);
    }
  }
}
